import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { Button } from '@/common/ui/button'
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/common/ui/form'
import { Input } from '@/common/ui/input'
import { Card, CardHeader, CardTitle, CardContent } from '@/common/ui/card'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { z } from 'zod'

const formSchema = z.object({
	password: z
		.string({
			required_error: 'จำเป็นต้องกรอกรหัสผ่าน',
		})
		.min(8, {
			message: 'ต้องกรอกรหัสผ่านอย่างน้อย 8 อักษร',
		}),
})

export interface ResetPasswordFormProps {
	handleSubmit: (value: any) => Promise<any> | void
}

export default function ResetPasswordForm({
	handleSubmit,
}: ResetPasswordFormProps) {
	const form = useForm({
		resolver: zodResolver(formSchema),
		defaultValues: {
			password: '',
		},
	})

	const onSubmit = async (values: z.infer<typeof formSchema>) => {
		try {
			await handleSubmit({
				password: values.password,
			})

			toast.success('เปลี่ยนรหัสผ่านสำเร็จ')

			form.reset()
		} catch (e) {
			showErrorToast(e as Error)
		}
	}

	return (
		<Card className="mx-auto w-full">
			<CardHeader>
				<CardTitle className="text-left text-2xl font-bold">
					เปลี่ยนรหัสผ่าน
				</CardTitle>
			</CardHeader>
			<CardContent>
				<Form {...form}>
					<form onSubmit={form.handleSubmit(onSubmit)} className="space-y-2">
						<FormField
							control={form.control}
							name="password"
							render={({ field }) => (
								<FormItem>
									<FormLabel htmlFor="password">รหัสผ่านใหม่</FormLabel>
									<FormControl>
										<Input
											type="password"
											placeholder="กรอกรหัสผ่านใหม่"
											{...field}
										/>
									</FormControl>
									<FormMessage />
								</FormItem>
							)}
						/>
						<Button type="submit">เปลี่ยนรหัสผ่าน</Button>
					</form>
				</Form>
			</CardContent>
		</Card>
	)
}
